module.exports = __webpack_public_path__ + "app/modals/wz-create-modal.view.html";